import React, { Suspense } from 'react';
import { ThemeProvider } from '../theme/ThemeProvider';
import { ThemeProvider as ContextProvider } from '../theme/ThemeContext';
import CircularProgress from '@mui/material/CircularProgress';
import { AuthProvider } from '../authContext/authContext';
import { SidebarProvider } from '../context/SideBarContext';
import { ToastProvider } from '../context/ToastContext';
import { useSessionManager } from '../hooks/useSessionManager';
import { useAuth } from '../authContext/useAuth';
import SessionExpiringModal from '../common/components/SessionExpiringModal';

const SessionManager = () => {
  const { isAuthenticated } = useAuth();
  const { showExpiringModal, handleLogoutNow, handleStayLoggedIn } = useSessionManager(
    isAuthenticated
      ? {
          idleTimeout: 30 * 60 * 1000,
          warningTimeout: 29 * 60 * 1000,
        }
      : {},
  );
  return (
    <>
      {isAuthenticated && (
        <SessionExpiringModal
          open={showExpiringModal}
          onLogout={handleLogoutNow}
          onStayLoggedIn={handleStayLoggedIn}
        />
      )}
    </>
  );
};

export default function Providers({ children }: any) {
  return (
    <Suspense fallback={<CircularProgress />}>
      <ContextProvider>
        <ToastProvider>
          <ThemeProvider>
            <AuthProvider>
              <SidebarProvider>
                <SessionManager />
                {children}
              </SidebarProvider>
            </AuthProvider>
          </ThemeProvider>
        </ToastProvider>
      </ContextProvider>
    </Suspense>
  );
}
